/// <amd-module name="Release/DeletedPipelines/DeletedPipelinesData" />
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";

export interface IDeletedDefinitionReference {
    id: number;
    name: string | null | undefined;
    path: string | null | undefined;
    deletedBy: IdentityRef | null | undefined;
    deletedOn: Date | undefined | null;
}

export interface IDeletedDefinitionProviderData {
    releaseDefinitions: IDeletedDefinitionReference[];
}
